import { useState } from "react";
import { assignCheckBookService, getCheckBookService } from "../api/services/checkbook";
import handleMessages from "../utils/HandleMessages";

const useCheckBook = () => {
  const [checkBooks, setCheckBooks] = useState([]);

  const getCheckBooks = async (pagina = 1) => {
    const res = await getCheckBookService(pagina);
    if (res.success) {
      setCheckBooks(res.data.response);
    }
  };

  const assignCheckBook = async(data) => {
    const res = await assignCheckBookService(data)
    return handleMessages(res)
  }

  return {
    checkBooks,
    getCheckBooks,
    assignCheckBook
  };
};

export default useCheckBook;
